import { useTranslation } from 'libs/i18n';
import { CompanyRegistrationAddress } from 'modules/onboarding/legal/components';

import { useRegistrationAddress, useOnboardingContext } from '../hooks';
import { PageComponentProps } from '../types';

export const RegistrationAddressStep = ({ canGoBack }: PageComponentProps) => {
  const {
    countries,
    countriesLoading,
    initialValues,
    submitLoading,
    onSubmit,
    goToBack,
  } = useRegistrationAddress();

  const { step } = useOnboardingContext();
  const { t } = useTranslation();

  return (
    <CompanyRegistrationAddress
      canGoBack={canGoBack}
      countries={countries}
      countriesLoading={countriesLoading}
      initialValues={initialValues}
      step={step}
      submitLoading={submitLoading}
      subTitle={t('onboarding.legalClientBranch.registrationAddress.subtitle')}
      title={t('onboarding.legalClientBranch.registrationAddress.title')}
      onGoBack={goToBack}
      onSubmit={onSubmit}
    />
  );
};
